export function getFiltro(state) {
  let filtro = '';
  filtro += `&filter[periodo]=${state.filtro.periodo.from},${state.filtro.periodo.to}`;

  return filtro;
}
